'use client';

import { c as _c } from "react/compiler-runtime";
import type { Provider } from '@repo/api-gw-sdk';
import { ResourceType } from '@repo/api-gw-sdk';
import { useMemo } from 'react';
import { useEnvironment } from '@/contexts/useEnvironment';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { ResourceTypes } from './resourceTypes';
export const useSupportedResourceTypes = t0 => {
  const $ = _c(15);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cloudProviders = t1;
  const {
    isDemo,
    isDev
  } = useEnvironment();
  const {
    AzureSqlDatabaseSupport,
    AzureSqlDiscovery,
    AzureSqlManagedInstanceSupport,
    MySqlFlexibleServerSupport,
    SapHanaPitrSupport,
    CassandraSupport,
    GoogleWorkspaceSupport,
    Microsoft365Support,
    EntraIdSupport,
    AwsEksClusterBackupSupport,
    GcpSqlVirtualMachineSupport
  } = useFeatureFlags();
  const isLocalEnv = isDemo || isDev;
  const t2 = AzureSqlDatabaseSupport || AzureSqlDiscovery;
  const t3 = !!GcpSqlVirtualMachineSupport;
  let t4;
  if ($[2] !== AwsEksClusterBackupSupport || $[3] !== AzureSqlManagedInstanceSupport || $[4] !== CassandraSupport || $[5] !== EntraIdSupport || $[6] !== GoogleWorkspaceSupport || $[7] !== Microsoft365Support || $[8] !== MySqlFlexibleServerSupport || $[9] !== SapHanaPitrSupport || $[10] !== cloudProviders || $[11] !== isLocalEnv || $[12] !== t2 || $[13] !== t3) {
    const resourceTypeEnabled = {
      [ResourceType.AwsCassandraCluster]: CassandraSupport,
      [ResourceType.GcpCassandraCluster]: CassandraSupport,
      [ResourceType.AzureCassandraCluster]: CassandraSupport,
      [ResourceType.AwsEksCluster]: AwsEksClusterBackupSupport,
      [ResourceType.AzureSapHanaVm]: SapHanaPitrSupport,
      [ResourceType.GcpSapHanaVm]: SapHanaPitrSupport,
      [ResourceType.AzureSqlDatabase]: t2,
      [ResourceType.AzureSqlManagedInstance]: AzureSqlManagedInstanceSupport,
      [ResourceType.AzureMysql]: MySqlFlexibleServerSupport,
      [ResourceType.GoogleWorkspaceResource]: GoogleWorkspaceSupport,
      [ResourceType.Microsoft365Resource]: Microsoft365Support,
      [ResourceType.AzureEntraIdResource]: EntraIdSupport,
      [ResourceType.AzureDisk]: false,
      [ResourceType.AzureCosmosdbMongodb]: false,
      [ResourceType.AzureCosmosdbNosql]: false,
      [ResourceType.AzureAksNamespace]: false,
      [ResourceType.GcpGkeNamespace]: false,
      [ResourceType.GcpCloudFirestore]: false,
      [ResourceType.GcpSqlVm]: t3
    };
    t4 = Object.values(ResourceType).filter(type => type !== ResourceType.ResourceTypeUnspecified && (cloudProviders.length ? cloudProviders.includes(ResourceTypes[type]?.provider) : true) && (isLocalEnv || (resourceTypeEnabled[type] ?? true)));
    $[2] = AwsEksClusterBackupSupport;
    $[3] = AzureSqlManagedInstanceSupport;
    $[4] = CassandraSupport;
    $[5] = EntraIdSupport;
    $[6] = GoogleWorkspaceSupport;
    $[7] = Microsoft365Support;
    $[8] = MySqlFlexibleServerSupport;
    $[9] = SapHanaPitrSupport;
    $[10] = cloudProviders;
    $[11] = isLocalEnv;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};